import { useState } from "react";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Pricing from "@/components/site/Pricing";
import Options from "@/components/site/Options";
import Gallery from "@/components/site/Gallery";
import WhyChooseUs from "@/components/site/WhyChooseUs";
import CTAFooter from "@/components/site/CTAFooter";
import MobileStickyBar from "@/components/site/MobileStickyBar";
import BookingDialog from "@/components/site/BookingDialog";
import useScrollReveal from "@/hooks/useScrollReveal";

export default function HomePage() {
  const [bookingOpen, setBookingOpen] = useState(false);
  const [bookingFormule, setBookingFormule] = useState("");

  useScrollReveal([]);

  const openBooking = () => {
    setBookingFormule("");
    setBookingOpen(true);
  };
  const bookWithFormule = (formule) => {
    setBookingFormule(formule || "");
    setBookingOpen(true);
  };

  return (
    <div className="min-h-screen bg-white pb-24 md:pb-0">
      <Header onOpenBooking={openBooking} />
      <main>
        <Hero onOpenBooking={openBooking} />
        <Gallery />
        <Pricing onBookFormule={bookWithFormule} />
        <Options onOpenBooking={openBooking} />
        <WhyChooseUs />
        <CTAFooter onOpenBooking={openBooking} />
      </main>
      <MobileStickyBar onOpenBooking={openBooking} />
      <BookingDialog
        open={bookingOpen}
        onOpenChange={setBookingOpen}
        defaultFormule={bookingFormule}
      />
    </div>
  );
}
